import React from "react";
import "./LegalNew.css";
import { FiShield, FiLock, FiServer, FiAlertCircle } from "react-icons/fi";

export default function Security() {

  // Professional Legal Version ID
  const legalId = "BAILCP-V-SC-2.2";
  const lastUpdated = "Dec 10, 2025";

  return (
    <div className="legal-page">
      <h1>Security</h1>

      {/* Legal Version / ID */}
      <div className="legal-meta">
        <span>Legal ID: {legalId}</span>
        <span>Last Updated: {lastUpdated}</span>
      </div>

      <p>
        At BodhAI, your data, privacy, and account safety are our top priorities.
        We follow industry-standard security practices to ensure strong
        protection across all systems.
      </p>

      <ul className="security-list">
        <li>
          <FiLock className="security-icon" />
          Encrypted passwords and secure authentication.
        </li>

        <li>
          <FiShield className="security-icon" />
          Optional two-factor authentication (2FA) for stronger account safety.
        </li>

        <li>
          <FiServer className="security-icon" />
          Secure cloud databases, firewalls, and regular backups.
        </li>

        <li>
          <FiAlertCircle className="security-icon" />
          Vulnerability reporting through our responsible disclosure program.
        </li>
      </ul>
    </div>
  );
}
